export default {"src":"/_next/static/media/cart-large.b2229c19.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};